
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1857 -86)"}},[_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7.5","transform":"translate(1857 86)","fill":"#e1f5f1"}}),_c('path',{attrs:{"d":"M1863.62 95.835a.807.807 0 01-1.142 0l-1.242-1.241a.808.808 0 011.143-1.143l.67.67 2.718-2.718a.808.808 0 011.142 1.142z","fill":"#22be9f"}})])])
          )
        }
      }
    